module.exports = __webpack_public_path__ + "static/media/Children_Cheering.9d3b68b0.wav";